import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { SourceService } from '@projects/services/SourceService';
import ItemForm from '@projects/components/project-add-source-form';
import ApiModal from '@projects/components/project-modal-source-api';

class SourceModalService extends ModalService {
  constructor() {
    super(SourceService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('projects.sources.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  edit(item) {
    return this.$open({
      title: i18n.t('projects.sources.modal.edit.title'),
      width: this.size.confirm,

      render: h =>
        h(ItemForm, {
          props: {
            item: item,
            is_edit: true
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  create(exist_name) {
    return this.$open({
      title: i18n.t('projects.create_task.modal_add_source.title'),
      width: this.size.confirm,

      render: h =>
        h(ItemForm, {
          props: {
            exist_name: exist_name
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  view_api(item) {
    return this.$open({
      title: i18n.t('projects.sources.modal.api.title'),
      width: 600,

      render: h =>
        h(ApiModal, {
          props: {
            item: item,
            is_edit: true
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new SourceModalService();
export { instance as SourceModalService };
